export default {"src":"/_next/static/media/mail.713cfcac.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};